module.exports = __webpack_public_path__ + "static/img/pair-figma.99c652ce.svg";